let _requireMap = null;

function setGameRequireMap(map) {
    _requireMap = map;
}

function syncRequireGameModule(name) {
    let func = _requireMap[name]
    return func();
}
module.exports = {
    setGameRequireMap: setGameRequireMap,
    syncRequireGameModule: syncRequireGameModule
}